import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    NewRentalTenantSnapshot,
    RentalTenantInput,
} from '../../models/RentalPayment';
import api from '../api';

const createTenants = (
    contractId: string,
    tenants: NewRentalTenantSnapshot[]
): Promise<RentalTenantInput[]> =>
    api.request<RentalTenantInput[]>({
        method: 'POST',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/tenants`,
        data: decamelizeKeys(tenants),
    });

const deleteTenant = (contractId: string, tenantId: number): Promise<void> =>
    api.request<void>({
        method: 'DELETE',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/tenants/${tenantId}`,
    });

export { createTenants, deleteTenant };
